import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Recaptcha from 'react-recaptcha';
import PropTypes from 'prop-types';

import {
  onValidRecaptcha,
  onExpiredReCapture,
  updateRecapture,
  resetRecaptureState,
} from '@app/actions/recaptchaActions';

import ErrorMessage from './ErrorMessage';

const recaptchaSiteKey = '6LcddosUAAAAAN4hTyNpIOYJeIPApSZy5X8AOsKW';

class RecaptchaComponent extends React.Component {
  recaptchaInstance = React.createRef()

  componentDidUpdate() {
    const { shouldRecaptureBeUpdated, updateRecapture } = this.props;
    if (shouldRecaptureBeUpdated) {
      this.recaptchaInstance.current.reset();
      updateRecapture();
    }
  }

  componentWillUnmount() {
    const { resetRecaptureState } = this.props;
    resetRecaptureState();
  }

  render() {
    const {
      onValidRecaptcha,
      onExpiredReCapture,
      locale,
      meta: { touched, error },
    } = this.props;
    const isError = touched && error;
    return (
      <RecaptchaContainer>
        <Recaptcha
          sitekey={recaptchaSiteKey}
          render="explicit"
          verifyCallback={onValidRecaptcha}
          expiredCallback={onExpiredReCapture}
          ref={this.recaptchaInstance}
          hl={locale}
        />
        {
          isError && <ErrorMessage error={error} />
        }
      </RecaptchaContainer>
    );
  }
}

RecaptchaComponent.propTypes = {
  onValidRecaptcha: PropTypes.func.isRequired,
  onExpiredReCapture: PropTypes.func.isRequired,
  shouldRecaptureBeUpdated: PropTypes.bool.isRequired,
  updateRecapture: PropTypes.func.isRequired,
  resetRecaptureState: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
    ]),
  }),
};

RecaptchaComponent.defaultProps = {
  meta: {},
};

const mapStateToProps = ({
  recaptcha: {
    shouldRecaptureBeUpdated,
  },
  intl: { locale },
}) => ({
  shouldRecaptureBeUpdated,
  locale,
});

const mapDispatchToProps = {
  onValidRecaptcha,
  onExpiredReCapture,
  updateRecapture,
  resetRecaptureState,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecaptchaComponent);

const RecaptchaContainer = styled.div`
  max-width: 100%;
  padding: 10px 0;
  text-align: left;
`;
